export const REQUIRED_GOOGLE_SHEETS_SCOPE = 'https://www.googleapis.com/auth/drive.file';

export interface SheetObject {
  sheetId: number;
  sheetName: string;
  spreadsheetId: string;
  spreadsheetName: string;
}
